import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/dueno-3-cierre.webp")